import { render, staticRenderFns } from "./ProceduresComingSoonPage.vue?vue&type=template&id=dddb8db0&scoped=true"
import script from "./ProceduresComingSoonPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceduresComingSoonPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProceduresComingSoonPage.vue?vue&type=style&index=0&id=dddb8db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddb8db0",
  null
  
)

export default component.exports